<p-breadcrumb [model]="routePath"></p-breadcrumb>
<div appAccessProvider [accessCode]="{ menuCode: 'SITES', pageCode: 'ALL', subPageCode: 'ADD' }">
  <app-module-header [label]="btnLabel" [showImportExportBtn]="showImportExportBtn" (onBtnClick)="onAddSite()"
    [showLastSync]="false"></app-module-header>
</div>
<div appAccessProvider [accessCode]="{ menuCode: 'SITES', pageCode: 'ALL', subPageCode: 'LIST' }">
  <p-tabView [(activeIndex)]="activeIndex" (onChange)="tabViewChange($event)" [scrollable]="true">
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="{{miIcons.DASHBOARD_ACTIVITY_FEED}} inline-block wh-14 mr-2 relative"></i>
        <span [ngClass]="{'active-tab-label': activeIndex === 0, 'inactive-tab-label': activeIndex !== 0}"
          class="tab-label" translate>lbl_all</span>&nbsp;<span
          class="iconNumber text-color-secondary">({{totalRecords}})</span>
      </ng-template>
      <ng-template pTemplate="body">
        @if(data){
        <app-mi-table
          [collectionOfColumns]="allColumns"
          [attributeLabels]="filterAttributeLabels"
          [data]="tableData"
          entityName="site"
          [isLoading]="isLoading"
          (onPageChange)="onPageChange($event)"
          (itemPerPageChange)="itemPerPageChange($event)"
          [totalRecords]="totalRecords"
          [itemsPerPage]="itemsPerPage"
          [message]="deleteSiteMsg"
          [header]="deleteSiteHeaderMsg"
          (onDelete)="onSiteDelete($event)"
          (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)"
          (onRowSelection)="onRowSelect($event)"
          [filterList]="filterList"
          (onValueChange)="onFilterValueChange($event)"
          [filterFields]="filterFieldsArray"
          [label]="btnLabel"
          (onBtnClick)="onAddSite()"
          [bulkUpdateLabel]="bulkUpdateLabel"
          [bulkDeleteLabel]="bulkDeleteLabel"
          [attributeData]="attributeData"
          (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
          (onSearchValueChange)="onSearchValueChanges($event)"
          (onUpdate)="onUpdateSite($event)"
          [rowItems]="rowItems"
          [bulkSelectionsItems]="bulkSelectionsItems"
          (setCurrentRowData)="setCurrentRowData($event)"
          [visiblePrintLabel]="visiblePrintLabel"
          [showBulkUpdateDialog]="showBulkUpdateDialog"
          (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
          [visible]="visible"
          [bulkUpdateHeader]="bulkUpdateHeader"
          [reviewHeader]="reviewHeader"
          [btnUpdate]="btnUpdate"
          [isEntity]="true"
          (onSortData)="onSortData($event)">
        </app-mi-table>
        }
      </ng-template>
    </p-tabPanel>
  </p-tabView>
</div>

<input hidden type="file" id="upload" (change)="onChange($event)"
  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" #uploader>